// extracted by mini-css-extract-plugin
export default {"herblist":"HerbPagination_herblist__AQGI1","title":"HerbPagination_title__LU6Pi","prv":"HerbPagination_prv__c8cTw","nxt":"HerbPagination_nxt__UyXWG"};